import { DateTime } from 'luxon';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SelectInput } from './select-input';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-flow: row;
  gap: 8px;
`;

interface DateOfBirthInputProps {
  value?: string;
  onChange?: (value: string) => void;
}

const range = (start: number, stop: number, step: number) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export const DateOfBirthInput = ({
  value,
  onChange,
}: DateOfBirthInputProps) => {
  const [month, setMonth] = useState('');
  const [day, setDay] = useState('');
  const [year, setYear] = useState('');
  const baseYear = new Date().getFullYear() - 12;

  const handleAll = (month: string, day: string, year: string) => {
    onChange?.(`${year}-${month}-${day}`);
  };

  const handleMonth = (value: string) => {
    setMonth(value);

    if (day && year) {
      handleAll(value, day, year);
    }
  };

  const handleDay = (value: string) => {
    setDay(value);

    if (month && year) {
      handleAll(month, value, year);
    }
  };

  const handleYear = (value: string) => {
    setYear(value);

    if (month && day) {
      handleAll(month, day, value);
    }
  };

  useEffect(() => {
    if (value) {
      const dateTime = DateTime.fromISO(value);

      if (dateTime.isValid) {
        setMonth(dateTime.toFormat('MM'));
        setDay(dateTime.toFormat('dd'));
        setYear(dateTime.toFormat('yyyy'));
      }
    }
  }, [value]);

  return (
    <Container>
      <SelectInput
        value={month}
        onChange={handleMonth}
        placeholder="MM"
        options={Array.from({ length: 12 }).map((_value, index) => {
          const value = String(index + 1).padStart(2, '0');
          return { label: value, value };
        })}
      />
      <SelectInput
        value={day}
        onChange={handleDay}
        placeholder="DD"
        options={Array.from({ length: 31 }).map((_value, index) => {
          const value = String(index + 1).padStart(2, '0');
          return { label: value, value };
        })}
      />
      <SelectInput
        value={year}
        onChange={handleYear}
        placeholder="YYYY"
        options={range(baseYear, baseYear - 80, -1).map((value) => ({
          label: `${value}`,
          value: `${value}`,
        }))}
      />
    </Container>
  );
};
